import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=40b5a5cc&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=40b5a5cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b5a5cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40b5a5cc')) {
      api.createRecord('40b5a5cc', component.options)
    } else {
      api.reload('40b5a5cc', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=40b5a5cc&scoped=true&", function () {
      api.rerender('40b5a5cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4PRIFhd3IBv0r/JS/comp/PopupDialog.vue"
export default component.exports